module.exports = __webpack_public_path__ + "static/media/squares.7ac47401.png";